<!-- Píldora de la topbar (prototipo `showMini` / `showPending`): círculo blanco de 28 px + texto 13px/700. -->
<button *ngIf="variant" type="button" class="fp-pill" [class.fp-pill--verify]="variant === 'verify'" (click)="open()" [disabled]="opening">
    <span class="fp-pill__icon" [class.fp-pill__icon--logo]="variant === 'activate'">
        <!-- Logo horizontal de color de Fina Pago en una cápsula blanca; el texto solo dice «Activar». -->
        <img *ngIf="variant === 'activate'" src="assets/img/fina-pago/logo-horizontal-t.png" alt="Fina Pago" />
        <i-feather *ngIf="variant === 'verify'" name="clock"></i-feather>
    </span>
    <span class="fp-pill__label">{{ label }}</span>
</button>
